<template>
  <div class="box" style="width: 100%">
    <div v-if="step === 'select'" style="width: 100%">
      <div class="m-slide-section">
        <h1 class="box-h">{{ dataSource.Description }}</h1>
        <h2 class="box-h"></h2>
      </div>
      <div class="m-slide-section">
        <div class="title">
          <div>
              <h4 class="box-h">
              <icon class="check-o" v-if="step1" name="check-circle-o" /><icon
                v-if="!step1"
                name="circle-o"
              />
              Step 1:
            </h4>
          </div>
          <div class="title-desc"> 
            <div class="title-detail"><h4 class="box-h">Select Target Area(s)</h4></div>
            <div class="title-icon">
              <b-link
                v-if="!this.$route.name.startsWith('geo')"
                @click="goGeo"
                class="title-edit"
              >
                <icon name="pencil" />
              </b-link>
            </div>
           </div>
        </div>
        <m-slide-item
          :items="geos"
          :deleteFun="deleteGeo"
          data-test="slide-order-geo"
        />
      </div>
      <div class="m-slide-section">
        <div class="title">
          <div>
            <h4 class="box-h">
            <icon
              class="check-o"
              v-if="step2 || demos.length > 0"
              name="check-circle-o"
            /><icon v-if="!step2 && demos.length === 0" name="circle-o" /> Step 2:
          </h4>
          </div>
          <div class="title-desc"> 
            <div class="title-detail"><h4 class="box-h">Define Target Audience</h4></div>
            <div class="title-icon">
              <b-link
                v-if="!this.$route.name.startsWith('demo') && demos.length > 0"
                @click="goDemo"
                class="title-edit"
              >
                <icon name="pencil" />
              </b-link>
            </div>
           </div>
        </div>
        <m-slide-item
          :items="demos"
          :deleteFun="deleteDemo"
          data-test="slide-order-demo"
        />
      </div>
      <div class="m-slide-section">
        <div>
          <h4 class="box-h">
            <icon name="circle-o" /> Step 3:
          </h4>
          </div>
          <div class="title-desc"> 
            <div class="title-detail"><h4 class="box-h">Review Count & Order</h4></div>
           </div>
      </div>
      <!-- <div style="display: flex; justify-content: center">
        <b-link v-b-modal.modal1 class="reset-order">Reset Order</b-link>
      </div> -->
    </div>
    <div v-if="step === 'summary'" style="width: 100%">
      <m-slide-summary />
    </div>
    <b-modal id="modal1" @ok="resetOrder" title="Confirm">
      <p class="my-4">Are you sure you want to reset your order?</p>
    </b-modal>
  </div>
</template>

<script>
import MSlideSummary from "@/components/slide/MSlideSummary.vue";
import MSlideItem from "@/components/slide/MSlideItem.vue";
import notification from "@/components/common/notification";

export default {
  components: {
    MSlideSummary,
    MSlideItem,
  },
  computed: {
    step() {
      if (
        this.$route.name === "summary" ||
        this.$route.name === "success" ||
        this.$route.name === "payment"
      ) {
        return "summary";
      } else {
        return "select";
      }
    },
    step1() {
      if (
        this.$route.name === "summary" ||
        this.$route.name.startsWith("geo") ||
        this.$route.name.startsWith("demo")
      ) {
        return true;
      } else {
        return false;
      }
    },
    step2() {
      if (
        this.$route.name === "summary" ||
        this.$route.name.startsWith("demo")
      ) {
        return true;
      } else {
        return false;
      }
    },
    demos() {
      return this.$store.getters["order/demos"];
    },
    geos() {
      return this.$store.getters["order/geos"];
    },
    dataSource() {
      return this.$store.getters["config/datasource"];
    },
    currentGeoType() {
      return this.$store.getters["order/currentGeoType"];
    },
  },
  methods: {
    deleteGeo(item) {
      this.$store.commit("order/deleteGeo", item.GeoKeyCode);
    },
    deleteDemo(item) {
      if (item.hasOwnProperty("is50")) {
        if (item.key === "target") {
          let targetoption = this.$store.getters["order/targetOption"];
          this.$store.commit("order/saveKey", [
            "TargetOption",
            targetoption - item.value,
          ]);
          this.$store.commit("demo/removeoption", {
            key: "target",
            val: item.value,
          });
        } else {
          let targetoption = this.$store.getters["order/routeOption"];
          this.$store.commit("order/saveKey", [
            "RouteOption",
            targetoption - item.value,
          ]);
          this.$store.commit("demo/removeoption", {
            key: "route",
            val: item.value,
          });
        }
      } else {
        this.$store.dispatch("order/deleteDemo", {
          type: "value",
          attributeValue: item.AttributeValue,
          columnName: item.ColumnName,
          name: item.AttributeValueName,
          demoCategoryType: item.DemoCategoryType,
        });
      }
    },
    resetOrder() {
      this.$store.dispatch(
        "order/initOrder",
        parseInt(this.$route.params.listType)
      );
      notification.notice("success", "Order has been reset");
    },
    goDemo() {
      this.$router.push({ name: "demo" });
    },
    goGeo() {
      if (
        this.currentGeoType.routeName &&
        this.currentGeoType.name !== 'totalUSA'
      ) {
        this.$router.push({ name: "geo" });
      } else {
        let geoType = this.currentGeoType.name;
        if (this.currentGeoType.title === "Radius Around an Address") {
          geoType = "radius";
        }
        this.$router.push({ name: "geo-" + geoType });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.title {
  display: flow;
  justify-content: space-between;
}

.title-desc {
  display: flex;
}

.title-detail {
  width: 90%;
}

.title-icon {
  width: 10%;
  text-align: right;
}

.box-h {
  color: $color-white;
}

.check-o {
  color: $color-primary;
}

.sub-title {
  color: $color-text-grey;
  font-size: $size-normal;
  font-weight: normal;
  margin-bottom: 1em;
}

.reset-order {
  margin-top: 24px;
  color: $color-white;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/slide/MSlide.vue